export const navigation = [
    {
        name: 'Phone',
        url: '#',
        icon: 'icon-phone',
        parent:true,
        children: [
            {
                name: 'Campaigns',
                url: '/phone/config/campaigns',
                icon: 'icon-home',
                profiles: ['qro', 'vna_user']
            },
            {
                name: 'Config',
                url: '#',
                icon: 'icon-settings',
                profiles: ['qro', 'vna_user', 'sales', 'external'],
                children: [
                    {
                        name: 'Services',
                        url: '#',
                        icon: 'icon-paper-clip',
                        profiles: []
                    },
                    {
                        name: 'Portal services',
                        url: '/phone/config/portal-services',
                        icon: 'icon-flag',
                        profiles: ['qro', 'vna_user']
                    },
                    {
                        name: 'Providers',
                        url: '/phone/config/providers',
                        icon: 'icon-star',
                        profiles: ['qro', 'vna_user']
                    },
                    {
                        name: 'Pricing',
                        url: '/phone/config/pricing',
                        icon: 'icon-wallet',
                        profiles: ['qro', 'vna_user']
                    },
                    {
                        name: 'Caller ids',
                        url: '/phone/config/caller-ids',
                        icon: 'icon-screen-smartphone',
                        profiles: ['qro', 'external']
                    },
                    {
                        name: 'Caller ids verifications',
                        url: '/phone/config/verification-caller-ids',
                        icon: 'icon-screen-smartphone',
                        profiles: ['qro', 'vna_user', 'sales', 'external']
                    },
                    {
                        name: 'Priorities',
                        url: '/phone/config/priorities',
                        icon: 'icon-screen-smartphone',
                        profiles: []
                    }
                ]
            },
            {
                name: 'Analytics',
                url: '#',
                icon: 'icon-speedometer',
                profiles: ['qro', 'sales', 'vna_user'],
                children: [
                    {
                        name: 'Outlay reporting',
                        url: '/phone/analytics/outlay-reporting',
                        icon: 'icon-wallet',
                        profiles: ['qro', 'sales', 'vna_user']
                    },
                    {
                        name: 'Outlay evolution',
                        url: '/phone/analytics/outlay-evolution',
                        icon: 'icon-wallet',
                        profiles: ['qro', 'sales', 'vna_user']
                    },
                    {
                        name: 'Logs',
                        url: '/phone/analytics/logs',
                        icon: 'icon-docs',
                        profiles: ['qro', 'vna_user']
                    },
                    {
                        name: 'Stats',
                        url: '/phone/analytics/stats',
                        icon: 'icon-pie-chart',
                        profiles: ['qro', 'sales', 'vna_user']
                    }
                ]
            },
            {
                name: 'Tools',
                url: '#',
                icon: 'icon-home',
                profiles: ['qro', 'vna_user'],
                children: [
                    {
                        name: 'Beeztel codes',
                        url: '/phone/tools/beeztel-codes',
                        icon: 'icon-list',
                        profiles: ['qro', 'vna_user']
                    },
                    {
                        name: 'Codes mapping',
                        url: '/phone/tools/codes-mapping-changes',
                        icon: 'icon-list',
                        profiles: ['qro', 'vna_user']
                    },
                    {
                        name: 'Search elements',
                        url: '/phone/tools/element-logs',
                        icon: 'icon-globe',
                        profiles: ['qro', 'vna_user']
                    },
                    {
                        name: 'Trace element',
                        url: '/phone/tools/trace-element',
                        icon: 'icon-paper-plane',
                        profiles: ['qro', 'vna_user']
                    },
                    {
                        name: 'Cache search',
                        url: '/phone/tools/element-cache',
                        icon: 'icon-layers',
                        profiles: ['qro', 'vna_user']
                    },
                ]
            }
        ]
    },
    {
        name: 'Client',
        url: '/clients',
        icon: 'icon-user',
        parent:true,
        profiles: ['vna_user', 'qro'],
        children: []
    },
    {
        name: 'Action',
        url: '/action',
        icon: 'icon-star',
        parent:true,
        profiles: ['vna_user', 'qro'],
        children: []
    },
    {
        name: 'Robinson',
        url: '#',
        icon: 'icon-star',
        parent:true,
        profiles: ['vna_user', 'qro'],
        children: [
            {
                name: 'Search',
                url: '/robinson/search',
                icon: 'icon-home',
                profiles: ['qro', 'vna_user']
            },
        ]
    },
    {
        name: 'Services',
        url: '/services',
        icon: 'icon-star',
        profiles: [],
        parent: true,
        children: []
    }
];



// WEBPACK FOOTER //
// /var/www/backend/src/app/_nav.ts